import Regex from '../domain/regex.mjs';

class Coordinator {

    #expressionElement;
    #dataElement;
    #resultElement;
    #flagElements;

    constructor () {
        this.#expressionElement = document.getElementById('expression');
        this.#dataElement = document.getElementById('data');
        this.#resultElement = document.getElementById('result');
        this.#flagElements = [
              {flag: 'g', element: document.getElementById('flag:global')}
            , {flag: 'i', element: document.getElementById('flag:ignoreCase')}
            , {flag: 'm', element: document.getElementById('flag:multiline')}
            , {flag: 's', element: document.getElementById('flag:dotAll')}
            , {flag: 'u', element: document.getElementById('flag:unicode')}
            , {flag: 'v', element: document.getElementById('flag:unicodeSets')}
            , {flag: 'y', element: document.getElementById('flag:sticky')}
        ];
        Object.freeze(this);
    }

    initialize () {
        this.#initializeEvents();
        this.#initializeEffects();

        const regex = window.localStorage.getItem('regex/expression') || '';
        const data = window.localStorage.getItem('regex/data') || '';
        this.#expressionElement.value = regex;
        this.#dataElement.value = data;
        this.#process(regex, data);
    }

    #initializeEvents () {
        window.addEventListener('paste', event => this.#onPaste(event));
        this.#expressionElement.addEventListener('change', event => this.#process(this.#expressionElement.value, this.#dataElement.value));
        this.#dataElement.addEventListener('change', event => this.#process(this.#expressionElement.value, this.#dataElement.value));

        for (const flagElement of this.#flagElements) {
            flagElement.element.addEventListener('change', event => this.#process(this.#expressionElement.value, this.#dataElement.value));
        }
    }

    #initializeEffects () {
        for (const element of document.getElementsByClassName("paste-effect")) {
            element.addEventListener('transitionend', event => event.target.classList.remove('pasted'));
        }
        for (const element of document.getElementsByClassName("click-effect")) {
            element.addEventListener('click', event => event.target.classList.add('clicked'));
            element.addEventListener('transitionend', event => event.target.classList.remove('clicked'));
        }
    }

    #process (regex, data) {
        const flags = 'd' + this.#flagElements.filter(x => x.element.checked).map(x => x.flag).join("");

        this.#resultElement.innerHTML = regex ? Regex.of(regex, flags).match(data) : data || '';

        window.localStorage.setItem('regex/expression', regex);
        window.localStorage.setItem('regex/data', data);
    }

    #onPaste (event) {
        if (event.target === document.activeElement) {
            return;
        }

        const paste = event.clipboardData.getData('text/plain');
        const isPasteRegex = !this.#expressionElement.value;
        const regex = isPasteRegex ? paste : this.#expressionElement.value;
        const data = isPasteRegex ? this.#dataElement.value : paste;
        const changedElement = isPasteRegex ? this.#expressionElement : this.#dataElement;

        changedElement.classList.add('pasted');
        this.#expressionElement.value = regex;
        this.#dataElement.value = data;
        this.#process(regex, data);
    }

}

export default new Coordinator ();
